import { ref } from 'vue'

// Starts at 1 so the initial (cold) page load counts as the first page view.
// router.afterEach (see app.vue) does not fire for the initial navigation, only
// for subsequent client-side navigations, so relying on it alone would leave the
// count at 0 on the landing page and suppress any popup configured with pageCount >= 1.
const pageCount = ref(1)

export const usePopupPageCount = () => {
    const incrementPageCount = () => {
        pageCount.value++
    }

    const getCurrentPageCount = () => pageCount.value

    const hasReachedExactPageCount = (requiredCount: number) => {
        return pageCount.value >= requiredCount
    }

    return { incrementPageCount, getCurrentPageCount, hasReachedExactPageCount }
}
